import FloatingFormItem from '@/components/_common/FloatingFormItem';
import InputDecimal from '@/components/_common/InputDecimal';
import { Checkbox, Col, Form, InputNumber, Row, Segmented } from 'antd';
import { useLabelPrintingContext } from '../..';
import { LabelPrintingLayoutOrientation } from '../../types';

export default function LabelPrintingToolbarLayoutPanel() {
  const { form } = useLabelPrintingContext();
  const presetChecked = Form.useWatch('preset', form);
  const oneCardPerPage = Form.useWatch(['layout', 'oneCardPerPage'], form);
  const disableLayout = presetChecked !== 'custom';

  return (
    <>
      <Row gutter={[16, 0]}>
        <Col span={24}>
          <Form.Item
            style={{ marginBottom: 12 }}
            name={['layout', 'orientation']}
          >
            <Segmented
              style={{ width: '100%' }}
              disabled={!disableLayout}
              options={[
                {
                  value: LabelPrintingLayoutOrientation.portrait,
                  label: 'Retrato',
                },
                {
                  value: LabelPrintingLayoutOrientation.landscape,
                  label: 'Paisagem',
                },
              ]}
            />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item
            name={['layout', 'oneCardPerPage']}
            initialValue={false}
            valuePropName="checked"
            style={{ marginBottom: 12 }}
          >
            <Checkbox>Uma etiqueta por página</Checkbox>
          </Form.Item>
        </Col>

        <Col span={24} sm={12}>
          <FloatingFormItem name={['layout', 'width']} label="Largura">
            <InputDecimal
              style={{ width: '100%' }}
              min={1}
              disabled={disableLayout}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} sm={12}>
          <FloatingFormItem name={['layout', 'height']} label="Altura">
            <InputDecimal
              style={{ width: '100%' }}
              min={1}
              disabled={disableLayout}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} sm={12}>
          <FloatingFormItem name={['layout', 'cols']} label="Colunas">
            <InputNumber
              style={{ width: '100%' }}
              min={1}
              disabled={oneCardPerPage}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} sm={12}>
          <FloatingFormItem
            name={['layout', 'gap']}
            label="Espaço entre colunas"
          >
            <InputDecimal
              style={{ width: '100%' }}
              min={1}
              disabled={oneCardPerPage}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} sm={12}>
          <FloatingFormItem
            name={['layout', 'marginInline']}
            label="Margem horizontal"
          >
            <InputDecimal style={{ width: '100%' }} min={0} />
          </FloatingFormItem>
        </Col>

        <Col span={24} sm={12}>
          <FloatingFormItem
            name={['layout', 'marginBlock']}
            label="Margem vertical"
          >
            <InputDecimal style={{ width: '100%' }} min={0} />
          </FloatingFormItem>
        </Col>
      </Row>
    </>
  );
}
